import { Message } from 'element-ui'

export function eltips(text, type = 'success', duration = 1800, customClass = '') {
	Message({
		message: text,
		type: type,
		center: true,
		offset: 200,
		customClass: customClass,
		duration: duration,
		showClose: !duration
	})
}
